import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Content = styled.div`
  display: grid;
  gap: 15px;
  padding: 10px 0;
`;

export const Description = styled(Typography.Body)`
  font-weight: 500;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const List = styled.ul`
  display: grid;
  gap: 10px;
  margin: 0;
  padding-left: 18px;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 15px;
  line-height: 24px;
`;

export const SubmitButton = styled(Button)`
  margin-top: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 10px 0 20px 0;
  }
`;
